import { render } from "./cretetimingdetail.vue?vue&type=template&id=6ec6902e&scoped=true"
import script from "./cretetimingdetail.vue?vue&type=script&lang=ts"
export * from "./cretetimingdetail.vue?vue&type=script&lang=ts"

import "./cretetimingdetail.vue?vue&type=style&index=0&id=6ec6902e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ec6902e"

export default script